import request from '@/utils/request'
/**
 * 获取 当前用户设备列表
 * */
export function getUserDevice(data) {
  return request({
    url: '/api/device/get-user-device',
    method: 'post',
    data
  })
}

/**
 * 登出指定设备
 * */
export function logoutDevice(data) {
  return request({
    url: '/api/device/logout-device',
    method: 'post',
    headers: {
      'X-Device-ID': localStorage.getItem('X-Device-ID')
    },
    data
  })
}

/**
 * 登出除指定外所有设备
 * */
export function logoutAllDevice(data) {
  return request({
    url: '/api/device/logout-all-device',
    method: 'post',
    headers: {
      'X-Device-ID': localStorage.getItem('X-Device-ID')
    },
    data
  })
}
